import { useEffect, useState } from 'react';
import QRCode from 'qrcode';
import { useT } from '../i18n';

/**
 * Renders a scannable QR code for the join URL so players can reach the site
 * without typing the (ugly) CloudFront domain. The 4-char game code is still
 * shown separately for players to enter after landing.
 */
export function JoinQR({ code }: { code: string }) {
  const t = useT();
  const [dataUrl, setDataUrl] = useState<string>('');
  // Encode the code in the path so scanning lands the player straight on the
  // game's join page — they only need to type a nickname.
  const joinUrl = `${window.location.origin}/play/${encodeURIComponent(code)}`;

  useEffect(() => {
    void QRCode.toDataURL(joinUrl, { margin: 1, width: 220, color: { dark: '#14110d', light: '#f4a300' } })
      .then(setDataUrl)
      .catch(() => setDataUrl(''));
  }, [joinUrl]);

  return (
    <div className="joinqr">
      {dataUrl && <img src={dataUrl} alt="Scan to join" width={220} height={220} />}
      <div className="joininfo">
        <div className="muted small">{t('qr.scan')}</div>
        <div className="bigcode">{code}</div>
      </div>
    </div>
  );
}
